export default "__VITE_PUBLIC_ASSET__b187010f__"